import { Badge } from '@ksyos/design-system';
import type { ProcessTaskStatus, ProcessTaskType } from '@common/enums';
import { ProcessStatus } from '@common/enums';
import { never } from '@common/utils/never';
import { getProcessTaskStatusLabel, ProcessTaskStatusRelation } from './processTaskStatus';

export function ProcessAdminStatus(props: {
    status: ProcessStatus;
    taskStatus?: ProcessTaskStatus;
    taskType?: ProcessTaskType;
}) {
    let label: string;
    if (props.taskType) {
        label = getProcessTaskStatusLabel(props.taskType, ProcessTaskStatusRelation.admin, props.taskStatus);
    } else {
        switch (props.status) {
            case ProcessStatus.closed:
                label = 'Gesloten';
                break;
            case ProcessStatus.cancelled:
                label = 'Geannuleerd';
                break;
            case ProcessStatus.active:
            case ProcessStatus.completed:
                label = 'Actief';
                break;
            default:
                never(props.status);
        }
    }

    return <Badge text={label} />;
}
